import React, { useState } from 'react';
import styles from './CommentForm.module.css';

interface CommentFormProps {
    onSubmit: (comment: { author: string; text: string }) => void;
    isHoliday?: boolean;
}

const CommentForm: React.FC<CommentFormProps> = ({ onSubmit, isHoliday = false }) => {
    const [name, setName] = useState<string>('');
    const [comment, setComment] = useState<string>('');
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!comment.trim()) return;

        onSubmit({
            author: name || 'Анонимный енот 🦝',
            text: comment
        });

        setName('');
        setComment('');
        setIsSubmitted(true);

        // Сбрасываем состояние успеха через 3 секунды
        setTimeout(() => setIsSubmitted(false), 3000);
    };

    return (
        <form
            onSubmit={handleSubmit}
            className={`${styles.form} ${isHoliday ? styles.holiday : ''} ${isSubmitted ? styles.success : ''}`}
        >
            <div className={styles.formGroup}>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Ваше имя (или псевдоним супергероя)"
                    className={styles.input}
                />
            </div>

            <div className={styles.formGroup}>
                <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Ваше мнение очень важно! (Но помните о вежливости) 😊"
                    required
                    rows={4}
                    className={styles.textarea}
                ></textarea>
            </div>

            <button type="submit" className={styles.button}>
                {isSubmitted ? "Отправлено! 🎉" : "Отправить комментарий"}
            </button>

            {isSubmitted && (
                <div style={{
                    marginTop: '15px',
                    padding: '10px',
                    background: 'rgba(76, 175, 80, 0.1)',
                    color: '#4caf50',
                    borderRadius: '8px',
                    textAlign: 'center',
                    border: '1px solid rgba(76, 175, 80, 0.3)',
                    fontSize: '0.9rem'
                }}>
                    Ваш комментарий отправлен! Спасибо, что делаете наш блог лучше! ✨
                </div>
            )}
        </form>
    );
};

export default CommentForm;